import React, { useState } from 'react';
import { IcoDownloadCloudArrowSmall } from '@icons';
import { downloadTrackRecord } from '@lib/api';
import { Button, Spinner } from 'react-bootstrap';

const DownloadTrackRecordButton = ({ aggregateId, trackRecordId, setSuccessMessageReport, setResult }) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleDownloadReport = async () => {
		setIsLoading(true);

		let sendResult = await downloadTrackRecord(aggregateId, { trackrecordId: trackRecordId });
		//console.log('sendResult', sendResult);

		if (sendResult.success) {
			setIsLoading(false);
			setResult('success');
			setSuccessMessageReport('Il report è in elaborazione e al completamento ti verrà inviata una notifica.');
		} else {
			setIsLoading(false);
			setResult('error');
		}
	};

	return (
		<Button
			disabled={isLoading}
			onClick={() => handleDownloadReport()}
			className="btn custom-primary-button"
			style={{
				height: '48px',
				width: '175px',
				display: 'flex',
				gap: '0.5rem',
				justifyContent: 'center',
				alignItems: 'center',
				fontWeight: 500,
			}}
		>
			{isLoading ? (
				<>
					<Spinner animation="border" size="sm" role="status" />
					scaricando...
				</>
			) : (
				<>
					<IcoDownloadCloudArrowSmall /> Scarica
				</>
			)}
		</Button>
	);
};
export default DownloadTrackRecordButton;
